<template>
    <div class="h-toolbarBg">
<!--        <ejs-toolbar ref="systemCounterBar">-->
<!--            <e-items>-->
<!--                <e-item prefixIcon='icon hero-icon hero-icon-add' tooltipText='门限设置' :click="sysCounterButtonClick" operate='create'></e-item>-->
<!--            </e-items>-->
<!--        </ejs-toolbar>-->
    </div>
</template>

<script>

    export default {
        name: "SystemCounterBar",
        props: [
        ],
        data() {
            return{
            }
        },
        methods: {
        },
        watch: {

        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>
